import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

export const renderRichText = (el, renderOptions = {}) => {
  if (!el) return null;

  const textObject = JSON.parse(el.raw);

  const defaultOptions = {
    renderText: (text) =>
      text.split('\n').reduce((acc, segment, i) => {
        return i === 0
          ? [segment]
          : [...acc, <br key={i} />, segment];
      }, []),
    ...renderOptions,
  };

  return documentToReactComponents(textObject, defaultOptions);
};

export function extractTextFromRichText(richTextRaw) {
  if (!richTextRaw) return '';

  let parsedContent;
  try {
    parsedContent =
      typeof richTextRaw === 'string' ? JSON.parse(richTextRaw) : richTextRaw;
  } catch (e) {
    return '';
  }

  let text = '';

  // Recursive function to extract text from nodes
  function extractFromNode(node) {
    if (node.nodeType === 'text' && node.value) {
      text += node.value + ' ';
    }
    if (node.content && Array.isArray(node.content)) {
      node.content.forEach(extractFromNode);
    }
  }

  // Process all top-level nodes
  if (parsedContent.content && Array.isArray(parsedContent.content)) {
    parsedContent.content.forEach(extractFromNode);
  }

  return text;
}
